<div [ngSwitch]="activity.activity">
  <span *ngSwitchCase="'invite.create'"
    >Invited <strong>{{ name }}</strong> to the project</span
  ><span *ngSwitchCase="'invite.accept'">Joined the project</span>
</div>
